import { SITE_NAME, SITE_ORIGIN, useSEO } from '@/hooks/useSEO';
import HeroSection from '@/pages/home/components/HeroSection';
import DigestStrip from '@/pages/home/components/DigestStrip';
import CategorySection from '@/pages/home/components/CategorySection';
import FeaturedFeed from '@/pages/home/components/FeaturedFeed';
import SummaryModeSection from '@/pages/home/components/SummaryModeSection';
import TestimonialSection from '@/pages/home/components/TestimonialSection';
import FaqSection, { FAQ_ITEMS } from '@/pages/home/components/FaqSection';
import SubscribeSection from '@/pages/home/components/SubscribeSection';

const HOME_JSON_LD = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'WebSite',
      name: SITE_NAME,
      alternateName: '5看料网速览快看',
      url: `${SITE_ORIGIN}/`,
      inLanguage: 'zh-CN',
      description: '5看料网以速览、快看与精简摘要的方式，帮助用户快速掌握娱乐与网络热点。',
      potentialAction: {
        '@type': 'SearchAction',
        target: `${SITE_ORIGIN}/hot?q={search_term_string}`,
        'query-input': 'required name=search_term_string',
      },
    },
    {
      '@type': 'Organization',
      name: SITE_NAME,
      url: `${SITE_ORIGIN}/`,
      email: 'hello@5kanliao.com',
      description: '专注娱乐与网络热点的速览型内容站点，主打碎片化阅读与精简摘要。',
    },
    {
      '@type': 'FAQPage',
      mainEntity: FAQ_ITEMS.map((item) => ({
        '@type': 'Question',
        name: item.q,
        acceptedAnswer: { '@type': 'Answer', text: item.a },
      })),
    },
  ],
};

export default function Home() {
  useSEO({
    title: '5看料网 | 速览快看，碎片精简摘要概览',
    description:
      '5看料网提供速览、快看、碎片化阅读与精简摘要模式，帮助你在三分钟内掌握娱乐与网络热点的核心信息。热门爆料、影视综艺、品牌风向一站概览。',
    keywords: '5看料网,速览,快看,碎片阅读,精简摘要,热点概览,娱乐爆料',
    path: '/',
    image:
      'https://readdy.ai/api/search-image?query=Warm%20cream%20editorial%20abstract%20composition%20with%20rounded%20card%20shapes%20and%20terracotta%20amber%20accents%2C%20flat%20minimal%20illustration%2C%20soft%20grain%20texture%2C%20clean%20modern%20magazine%20layout&width=1200&height=630&seq=kanliao-og-home&orientation=landscape',
    jsonLd: HOME_JSON_LD,
  });

  return (
    <>
      <HeroSection />
      <DigestStrip />
      <CategorySection />
      <FeaturedFeed />
      <SummaryModeSection />
      <TestimonialSection />
      <FaqSection />
      <SubscribeSection />
    </>
  );
}